import { z } from 'zod';

export const WithdrawalSchema = z.object({
    phone: z.string(),
    sum: z
        .string()
        .min(1)
        .refine(val => (parseInt(val) || 0) <= 2000, 'Максимум - 2000 бонусов в месяц'),
});
